"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

var config_1 = require("../config");

var PurchaseModule =
/** @class */
function (_super) {
  __extends(PurchaseModule, _super);

  function PurchaseModule() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.getPurchaseUrl = function () {
      var _a = _this.props,
          personId = _a.personId,
          outputGroupId = _a.outputGroupId;
      return config_1.getPurchaseUrl(outputGroupId, personId);
    };

    _this.shouldRenderIframe = function () {
      var _a = _this.props,
          personId = _a.personId,
          outputGroupId = _a.outputGroupId;
      return !!(personId && outputGroupId);
    };

    return _this;
  }

  PurchaseModule.prototype.render = function () {
    if (!this.shouldRenderIframe()) {
      return null;
    }

    var IFrameComponent = this.props.IFrameComponent;
    return react_1.default.createElement(Container, null, react_1.default.createElement(IFrameComponent, {
      source: this.getPurchaseUrl(),
      height: "90vh"
    }));
  };

  return PurchaseModule;
}(react_1.PureComponent);

exports.PurchaseModule = PurchaseModule;
var Container = styled_components_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    overflow: hidden;\n    background: white;\n"], ["\n    overflow: hidden;\n    background: white;\n"])));
var templateObject_1;